import widgetActionData from '../../../../platform_common_constants/widget_action_constants.json'

export const actionAlignment = widgetActionData.ACTION_ALIGNMENT;
export const widgetActionType = widgetActionData.ACTION_TYPE;
export const widgetActionSection = widgetActionData.ACTION_SECTION;
export const widgetActionPosition = widgetActionData.ACTION_POSITION;